import React, { useState } from 'react';

const ContentContext = React.createContext();

const ContentProvider = (props) => {
  const [content, setContent] = useState(props.value)

  return (
    <ContentContext.Provider value={[content, setContent]}>
      {props.children}
    </ContentContext.Provider>
  );
};

export { ContentContext, ContentProvider}
